'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serialize = serialize;
exports.deserialize = deserialize;

var _omit = require('transmute/omit');

var _omit2 = _interopRequireDefault(_omit);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _pick = require('transmute/pick');

var _pick2 = _interopRequireDefault(_pick);

var _merge = require('transmute/merge');

var _merge2 = _interopRequireDefault(_merge);

var _toJS = require('transmute/toJS');

var _toJS2 = _interopRequireDefault(_toJS);

var _PubNubMessageTypes = require('conversations-schema/constants/PubNubMessageTypes');

var _PubNubMessageFactory = require('conversations-schema/factories/PubNubMessageFactory');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYS_TO_SERIALIZE = ['client', 'clientTs', 'metadata', 'senderId', 'senderType', 'timestamp', 'text', 'from', 'url', 'richText', 'messageId', 'type'];

var TOP_LEVEL_KEYS = ['client', 'clientTs', 'senderId', 'timestamp'];

function serialize(message) {
  return (0, _pipe2.default)(_toJS2.default, function (payload) {
    // Create a V1-V2 Hybrid message to maintain compatibility with older clients
    var hybridPayload = (0, _merge2.default)(payload.metadata, payload);
    hybridPayload.messageId = payload.metadata.welcomeMessageId;
    hybridPayload.type = payload.metadata[_PubNubMessageTypes.MESSAGE_TYPE_ID];
    return hybridPayload;
  }, (0, _pick2.default)(KEYS_TO_SERIALIZE))(message);
}

function deserialize(json) {
  var factoryFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _PubNubMessageFactory.buildPublishedMessage;

  if ((0, _PubNubMessageModel.getType)(json)) return factoryFn(json);

  // Convert V1 message to V2 to maintain compatibility with older clients
  var metadata = (0, _omit2.default)(TOP_LEVEL_KEYS, json);

  json.metadata = metadata;
  json.metadata.welcomeMessageId = metadata.messageId;
  json.metadata[_PubNubMessageTypes.MESSAGE_TYPE_ID] = metadata.type;

  return factoryFn(json);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/serializers/PubNubMessageSerializer.js
// module id = 121
// module chunks = 0 1